(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './filter', './map', './orderBy', './reject', './shuffle', './sortBy'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./filter'), require('./map'), require('./orderBy'), require('./reject'), require('./shuffle'), require('./sortBy'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.filter, global.map, global.orderBy, global.reject, global.shuffle, global.sortBy);
    global.index = mod.exports;
  }
})(this, function (exports, _filter, _map, _orderBy, _reject, _shuffle, _sortBy) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.sortBy = exports.shuffle = exports.reject = exports.orderBy = exports.map = exports.filter = undefined;
  exports.filter = _filter.filter;
  exports.map = _map.map;
  exports.orderBy = _orderBy.orderBy;
  exports.reject = _reject.reject;
  exports.shuffle = _shuffle.shuffle;
  exports.sortBy = _sortBy.sortBy;
});